import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppNavigationComponent } from './app-navigation.component';
import { AppNavTabComponent } from './app-nav-tab.component';
import { AppNavMenuItemComponent } from './app-nav-menu-item.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  declarations: [
    AppNavigationComponent,
    AppNavTabComponent,
    AppNavMenuItemComponent,
  ],
  exports: [
    AppNavigationComponent,
    AppNavTabComponent,
    AppNavMenuItemComponent,
  ]
})
export class AppNavigationModule {}
